/**
 * Очищает данные пользовательской сессии из localStorage
 */
export function clearUserSessionData() {
	for (const localStorageKey in localStorage) {
		if(!localStorageKey.startsWith('setting.')
			&& !localStorageKey.startsWith('dev.')
			&& localStorageKey !== 'devMode'
			&& localStorageKey !== 'coreDevMode') {
			localStorage.removeItem(localStorageKey)
		}
	}
}
